import { styled } from 'styled-components';

import { styledTypography } from '@pkg/primitives';

export const PageWrapper = styled.div`
    max-width: 1920px;
    margin: 0 auto;
    padding: 0 40px;
    position: relative;
    height: 100%;

    @media (max-width: 768px) {
        padding: 0 20px;
    }
`;

export const ContentWrapper = styled.div`
    padding: 50px 0 0 0;

    @media (max-width: 768px) {
        padding: 30px 0 0 0;
    }
`;

export const LoaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding: 50px;
`;

export const LoaderHolder = styled.div`
    width: 160px;
`;

export const PanelTitle = styled.h1`
    ${styledTypography.allianceBase};
    font-size: 32px;
    font-weight: 700;
`;
